import React from "react";
import { Typography, Toolbar } from "@material-ui/core";
import AllPostsConnector from "../posts/AllPostsConnector";
import { Switch, Route } from "react-router-dom";
import MainPage from "./MainPage";
import FramePage from "../frame/FramePage";

const Body = () => (
  <>
    <Toolbar />
    <Switch>
      <Route exact path="/">
        <MainPage />
      </Route>
      {window.AppInfo.showNews && (
        <Route exact path="/news">
          <AllPostsConnector />
        </Route>
      )}
      <Route path="/open">
        <FramePage />
      </Route>
      <Route>
        <Typography>{window.t["Page not found"]}</Typography>
      </Route>
    </Switch>
  </>
);

export default Body;
